module.exports = __webpack_public_path__ + "img/bubble-field.72db83c8.svg";